export default {
    computed: {
        cardDropdownSettings() {
            let options = [];

            if (this.billingSources.length) {
                options = this.sortedBillingSources;
            }

            return {
                options: options,
                valueField: 'id',
                maxItems: 1,
                dropdownParent: 'body',
                render: {
                    item: this.cardDropdownItem,
                    option: this.cardDropdownOption
                },
            };
        },

        cardDropdownAutoRechargeSettings() {
            let options = [];

            if (this.billingSources.length) {
                options = this.sortedBillingSources;
            }

            return {
                options: options,
                valueField: 'id',
                maxItems: 1,
                dropdownParent: 'body',
                render: {
                    item: this.cardDropdownItem,
                    option: this.cardDropdownOption
                },
            };
        },
    },

    methods: {
        cardDropdownItem(item, escape) {
            if (item.isTypeAch) {
                return `
                    <div class="selectize-card is-item">
                        <span class="selectize-card-icon icon is-card is-small is-ach">
                            <i class="card-${this.cardDropdownBrandIcon(item)}"></i>
                        </span>
                        <div class="selectize-card-details">
                            <div class="selectize-card-details-box">
                                <div class="selectize-card-details-item">
                                    ${item.name}
                                </div>
                                <div class="selectize-card-details-item">
                                    ******${escape(item.last4)}
                                </div>
                            </div>
                        </div>
                    </div>
                `;
            }

            return `
                <div class="selectize-card is-item">
                    <span class="selectize-card-icon icon is-card is-small">
                        <i class="card-${this.cardDropdownBrandIcon(item)}"></i>
                    </span>
                    <div class="selectize-card-details">
                        <div class="selectize-card-details-box">
                            <div class="selectize-card-details-item">
                                ******${escape(item.last4)}
                            </div>
                            <div class="selectize-card-details-item">
                                ${escape(this.formatCardExpiry(item))}
                            </div>
                        </div>
                        ${(item.primary ? '<span class="tag is-primary selectize-card-details-box">Primary</span>' : '')}
                    </div>
                </div>
            `;
        },

        cardDropdownOption(item, escape) {
            if (item.isTypeAch) {
                return `
                    <div class="selectize-card is-option">
                        <span class="selectize-card-icon icon is-card is-small is-ach">
                            <i class="card-${this.cardDropdownBrandIcon(item)}"></i>
                        </span>
                        <div class="selectize-card-details">
                            <div class="selectize-card-details-box">
                                <div class="selectize-card-details-item">
                                    ${item.name}
                                </div>
                                <div class="selectize-card-details-item">
                                    ******${escape(item.last4)}
                                </div>
                            </div>
                        </div>
                    </div>
                `;
            }

            return `
                <div class="selectize-card is-option">
                    <span class="selectize-card-icon icon is-card is-small">
                        <i class="card-${this.cardDropdownBrandIcon(item)}"></i>
                    </span>
                    <div class="selectize-card-details">
                        <div class="selectize-card-details-box">
                            <div class="selectize-card-details-item">
                                ******${escape(item.last4)}
                            </div>
                            <div class="selectize-card-details-item">
                                ${escape(this.formatCardExpiry(item))}
                            </div>
                        </div>
                        ${(item.primary ? '<span class="tag is-primary selectize-card-details-box">Primary</span>' : '')}
                    </div>
                </div>`;
        },

        cardDropdownBrand(brand) {
            switch (brand?.toLowerCase().replace(' ', '')) {
            case 'visa':
                return 'Visa';
            case 'mastercard':
                return 'Mastercard';
            case 'americanexpress':
            case 'amex':
                return 'American Express';
            case 'discover':
                return 'Discover';
            case 'jcb':
                return 'JCB';
            case 'dinersclub':
                return 'Diners Club';
            }

            return brand;
        },

        cardDropdownBrandIcon(card) {
            return card.brand.replace(' ', '-').toLowerCase();
        },
    }
};
